import { useState, type SyntheticEvent, type JSX } from 'react';
import { useSearchParams } from 'react-router';
import { AuthLayout } from '../app/AuthLayout';
import { useT } from '../i18n/useT';
import { normalizeReturnUrl, useLoginFlow } from './useLoginFlow';

export const LoginScreen = (): JSX.Element => {
  const t = useT();
  const [params] = useSearchParams();
  const returnUrl = normalizeReturnUrl(params.get('returnUrl'));
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [password, setPassword] = useState('');
  const { submit, error, busy } = useLoginFlow();

  const onSubmit = (event: SyntheticEvent): void => {
    event.preventDefault();
    void submit(email, password, returnUrl);
  };

  return (
    <AuthLayout>
      <h1 className="ow-heading">{t('Sign in')}</h1>
      <p className="ow-muted">{t('Use your Invite account to continue.')}</p>
      <form className="ow-form" onSubmit={onSubmit}>
        <label className="ow-label">
          {t('Email')}
          <input
            type="email"
            name="email"
            className="ow-field"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            autoComplete="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
          />
        </label>
        <label className="ow-label">
          {t('Password')}
          <input
            type="password"
            name="password"
            className="ow-field"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            autoComplete="current-password"
            required
          />
        </label>
        {error !== null ? (
          <p className="ow-error" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" className="ow-btn-primary" disabled={busy}>
          {t('Sign in')}
        </button>
      </form>
    </AuthLayout>
  );
};
